/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_AmountInputs */

const en_admin_plan_discount_form_amount = /** @type {(inputs: Admin_Plan_Discount_Form_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const de_admin_plan_discount_form_amount = /** @type {(inputs: Admin_Plan_Discount_Form_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betrag`)
};

const es_admin_plan_discount_form_amount = /** @type {(inputs: Admin_Plan_Discount_Form_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe`)
};

const fr_admin_plan_discount_form_amount = /** @type {(inputs: Admin_Plan_Discount_Form_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant`)
};

const nl_admin_plan_discount_form_amount = /** @type {(inputs: Admin_Plan_Discount_Form_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrag`)
};

const it_admin_plan_discount_form_amount = /** @type {(inputs: Admin_Plan_Discount_Form_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importo`)
};

const pt_br2_admin_plan_discount_form_amount = /** @type {(inputs: Admin_Plan_Discount_Form_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

const pl_admin_plan_discount_form_amount = /** @type {(inputs: Admin_Plan_Discount_Form_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwota`)
};

const hu_admin_plan_discount_form_amount = /** @type {(inputs: Admin_Plan_Discount_Form_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összeg`)
};

const ro_admin_plan_discount_form_amount = /** @type {(inputs: Admin_Plan_Discount_Form_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suma`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Admin_Plan_Discount_Form_AmountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_amount = /** @type {((inputs?: Admin_Plan_Discount_Form_AmountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_AmountInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_amount(inputs)
	if (locale === "de") return de_admin_plan_discount_form_amount(inputs)
	if (locale === "es") return es_admin_plan_discount_form_amount(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_amount(inputs)
	if (locale === "nl") return nl_admin_plan_discount_form_amount(inputs)
	if (locale === "it") return it_admin_plan_discount_form_amount(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_amount(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_amount(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_amount(inputs)
	return ro_admin_plan_discount_form_amount(inputs)
});
export { admin_plan_discount_form_amount as "admin.plan_discount_form.amount" }